const TILE_TYPE_CATEGORY = 'category';
const TILE_TYPE_CMS = 'cms';
const TILE_TYPE_COLLECTION = 'collection';
const TILE_TYPE_CREATOR = 'creator';
const TILE_TYPE_INTERIORS = 'interiors';
const TILE_TYPE_ITEM = 'item';
const TILE_TYPE_SHOPPER = 'shopper';

export const TILE_TYPES = {
    CATEGORY: TILE_TYPE_CATEGORY,
    CMS: TILE_TYPE_CMS,
    COLLECTION: TILE_TYPE_COLLECTION,
    CREATOR: TILE_TYPE_CREATOR,
    INTERIORS: TILE_TYPE_INTERIORS,
    ITEM: TILE_TYPE_ITEM,
    SHOPPER: TILE_TYPE_SHOPPER,
};
